export default __webpack_public_path__ + "static/media/signature.46a6eb9c.png";